<!-- Because of bootstrap instaleld on this project, we need to change the class  -->
<div class="modal__channels" #modal>
	<div class="modal__channels__after" (click)="closeOutside()"></div>
	<div class="modal__channels__wrapper">
		<ng-content></ng-content>
	</div>
</div>
